import React from 'react';
import { IGroupDto, IPatientListDto } from '../../services/api/api-client';

export const PatientCardContext = React.createContext<{
  patient: IPatientListDto;
  group: IGroupDto;
}>(undefined as any);
